import React from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';

import { 
  Auth, 
  Logger,
} from 'aws-amplify';

import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from '@material-ui/core';

import { 
  makeStyles,
} from '@material-ui/core/styles';

import {
  AccountCircle as AccountCircleIcon,
  DataUsage as DataUsageIcon,
  FlashOn as ExecutionIcon,
  Label as LabelIcon,
  ImportContacts as CatalogIcon,
} from '@material-ui/icons';

import { 
  ResourcePolyIcon,
} from '../../resource';

const logger = new Logger('ConsoleSideMenu');

const drawerWidth = 240;

const useStyles = makeStyles({
  root: {
    width: 250,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: 'auto',
  },
});

const fmtResourceType = (resourceType) => {
  return resourceType.replace(/([A-Z]+)*([A-Z][a-z])/g, "$1 $2")+'s';
};

export default function ConsoleSideMenu(props) {

  const { resources, open, onClose } = props;

  const classes = useStyles();
  const history = useHistory();
  
  let databases = 0;
  let resourceData = {};
  resources.forEach( resource => {
    if (resource._mutationType !== 'REMOVE') {
      if(!(resource.ResourceType in resourceData)) {
        resourceData[resource.ResourceType]={
          name: fmtResourceType(resource.ResourceType),
          type: resource.ResourceType,
          target: '/resources/'+resource.ResourceType.toLowerCase()+'s',
          count: 0
        };
      }
      resourceData[resource.ResourceType].count+=1;
      if (resource.ResourceType === 'Dataset' 
        && resource.CatalogConfiguration 
        && resource.CatalogConfiguration.Status ==='ENABLED') {
        databases++;
      }
    }
  });
  let resourceItems = Object.keys(resourceData).map(function(key){
      return resourceData[key];
  });
  resourceItems.sort((a,b) => a.name.localeCompare(b.name));

  const handleItemSelect = (event, value) => {
    logger.info("SELECTED: ",event, value);
    if(resourceData[value]) {
      history.push(resourceData[value].target);
    } else if(value==='SignOut') {
      Auth.signOut({ global: true });
    } else {
      history.push('/'+value.toLowerCase());
    }
    handleDrawerClose();
  };

  const toggleSideMenu = (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    handleDrawerClose();
  }; 
  
  const handleDrawerClose = () => {
    if(onClose) {
      onClose(); 
    }
  };
  
  return (
    <Drawer anchor="left" open={open} onClose={toggleSideMenu}>
      <div className={classes.drawerContainer}>
        <div
          className={classes.root}
          role="presentation"
        >
          <List>
            <ListItem button key="Dashboard" onClick={(event) => handleItemSelect(event, "Dashboard")}>
              <ListItemIcon><DataUsageIcon/></ListItemIcon>
              <ListItemText primary={"Dashboard"} />
            </ListItem>
            {databases?
              <ListItem button key="Catalog" onClick={(event) => handleItemSelect(event, "Catalog")}>
                <ListItemIcon><CatalogIcon/></ListItemIcon>
                <ListItemText primary={"Catalog"} />
                <ListItemSecondaryAction>
                  <Typography variant='caption'>{databases}</Typography>
                </ListItemSecondaryAction>
              </ListItem>:null
            }
            <ListItem button key="Resources" onClick={(event) => handleItemSelect(event, "Resources")}>
              <ListItemIcon><ResourcePolyIcon/></ListItemIcon>
              <ListItemText primary={"Resources"} />
              <ListItemSecondaryAction>
                <Typography variant='caption'>{resources.length}</Typography>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
          <Divider />
          <List>
            {resourceItems.map((item) => (
              <ListItem button key={item.name} onClick={(event) => handleItemSelect(event, item.type)}>
                <ListItemIcon><ResourcePolyIcon type={item.type}/></ListItemIcon>
                <ListItemText primary={item.name} />
                <ListItemSecondaryAction>
                  <Typography variant='caption'>{resourceData[item.type].count}</Typography>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
          <Divider />
          <List>
            <ListItem button key="Executions" onClick={(event) => handleItemSelect(event, "Executions")}>
              <ListItemIcon><ExecutionIcon/></ListItemIcon>
              <ListItemText primary={"Executions"} />
            </ListItem>
            <ListItem button key="Account" onClick={(event) => handleItemSelect(event, "Account")}>
              <ListItemIcon><AccountCircleIcon/></ListItemIcon>
              <ListItemText primary={"Account"} />
            </ListItem>
            <ListItem button key="SignOut" onClick={(event) => handleItemSelect(event, "SignOut")}>
              <ListItemIcon><LabelIcon/></ListItemIcon>
              <ListItemText primary={"Sign Out"} />
            </ListItem>
          </List>
        </div>
      </div>
    </Drawer>
  );
}

ConsoleSideMenu.propTypes = {
  resources: PropTypes.array.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

ConsoleSideMenu.defaultProps = {
  open: false,
};


